module.exports = __webpack_public_path__ + "static/img/service_icon_bg_sel@2x.1613aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images2/service_icon_bg_sel@2x.png
// module id = 0hmJ
// module chunks = 1